import "toastr/build/toastr.css";

// toastr depends on a version of jQuery which gets bundled with it
// the following is a wrapper around toastr that both
// 1) sets our desired options
// 2) asynchronously fetches toastr and the jQuery dependency only when needed, decreasing our main bundle size significantly

// to preload toastr, just call the getToastr function

let toastr: any = null;

async function getToastr() {
  if (!toastr) {
    toastr = await import("toastr");
    toastr.options.positionClass = "toast-top-center";
    toastr.options.target = "#toastr-container";
  }
  return toastr;
}

async function success(msg: string) {
  (await getToastr()).success(msg);
}

async function error(msg: string) {
  (await getToastr()).error(msg);
}

export default { success, error, getToastr };



// WEBPACK FOOTER //
// ./app/javascript/utils/toast.ts